import { forwardRef } from 'react'
import { FormControl, FormErrorMessage, FormLabel, Radio, RadioGroup, VStack } from '@chakra-ui/react'

import { Option } from '../utils'

type EnumRadioGroupProps = {
    name: string
    label: string
    options: Option[]
    value?: number | null
    onChange: (value: number) => void
    onBlur: () => void
    errorMessage?: string
    isDisabled?: boolean
    isRequired?: boolean
    isInvalid?: boolean
}

export const EnumRadioGroup = forwardRef<HTMLDivElement, EnumRadioGroupProps>(
    ({ name, label, options, value, onChange, onBlur, errorMessage, isDisabled, isRequired, isInvalid }, ref) => (
        <FormControl isInvalid={isInvalid} isDisabled={isDisabled} isRequired={isRequired}>
            <FormLabel htmlFor={name}>{label}</FormLabel>
            <RadioGroup
                onChange={v => onChange(Number(v))}
                // Empty string keeps the group controlled so clearing the form value unchecks the radios
                value={value !== undefined && value !== null ? String(value) : ''}
                name={name}
                onBlur={onBlur}
                ref={ref}>
                <VStack alignItems="flex-start">
                    {options.map(({ value: optionValue, label: optionLabel }) => (
                        <Radio key={optionValue} value={optionValue}>
                            {optionLabel}
                        </Radio>
                    ))}
                </VStack>
            </RadioGroup>
            <FormErrorMessage>{errorMessage}</FormErrorMessage>
        </FormControl>
    ),
)

EnumRadioGroup.displayName = 'EnumRadioGroup'
